export type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const LEVELS: Record<LogLevel, number> = { debug: 0, info: 1, warn: 2, error: 3 };

function resolveMinLevel(): number {
  const override = (import.meta.env.VITE_LOG_LEVEL as LogLevel | undefined);
  if (override && override in LEVELS) return LEVELS[override];
  return import.meta.env.DEV ? LEVELS.debug : LEVELS.warn;
}

export interface LogSink {
  debug(...args: unknown[]): void;
  info(...args: unknown[]): void;
  warn(...args: unknown[]): void;
  error(...args: unknown[]): void;
}

let activeSink: LogSink = console;
const minLevel = resolveMinLevel();

export function setLogSink(sink: LogSink): void {
  activeSink = sink;
}

export function createLogger(scope?: string): LogSink {
  const prefix = scope ? `[${scope}]` : undefined;
  function emit(level: LogLevel, args: unknown[]): void {
    if (LEVELS[level] < minLevel) return;
    activeSink[level](...(prefix ? [prefix, ...args] : args));
  }
  return {
    debug: (...args) => emit('debug', args),
    info:  (...args) => emit('info',  args),
    warn:  (...args) => emit('warn',  args),
    error: (...args) => emit('error', args),
  };
}

export const log = createLogger();
